import React from 'react';

function ModalCompanyDialog(props) {
  const { refModal, search, searchName, currentCompanies, setCompany } = props;

    return (
      <div ref={refModal} className="modal">
        <div className="modal-content">
          <h5>Company UID</h5>
          <div className="row">
            <div className="input-field col s12">
              <input
                id="searchName"
                type="text"
                className="validate"
                value={searchName}
                name="searchName"
                onChange={(e) => {
                  search(e.target.value);
                }}
              />
              <label htmlFor="searchName">Company name</label>
            </div>
          </div>
          <div className="search-container">
            {currentCompanies.map((company) => {
              return (
                <div key={company.id}>
                  <a
                    href="#!"
                    onClick={(e) => {
                      setCompany(company);
                      search('');
                    }}
                    className="modal-close waves-effect btn btn-flat">
                    {company.companyName}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
        <div className="modal-footer">
          <a
            href="#close"
            className="modal-close waves-effect btn btn-flat"
            onClick={(e) => {
              search('');
            }}>
            {' '}
            Cancel
          </a>
        </div>
      </div>
    );
}

export default ModalCompanyDialog;
